import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { ORGANIZATION_API_PATH } from "@/modules/Organization/constants";
import { IOrganization } from "@/core/interfaces/organization.interface";
import {
  PricingCreationForm,
  PricingItem,
} from "@/core/interfaces/managePricing.interface";
import { CreatePricingDto, UpdatePricingDto } from "../dtos/managePricing.dto";
import { formatString } from "@/core/utils/helpers";

class ManagePricingService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public getPricingForm(): Promise<ICoreResponse<PricingCreationForm>> {
    return this.restClient.get(ORGANIZATION_API_PATH.GET_PRICING_CREATION_FORM);
  }

  public getAll(): Promise<ICoreResponse<IOrganization[]>> {
    return this.restClient.get(ORGANIZATION_API_PATH.GET);
  }
  public getPricingList(orgId: string): Promise<ICoreResponse<PricingItem[]>> {
    return this.restClient.get(
      formatString(ORGANIZATION_API_PATH.GET_PRICING_LIST, orgId),
    );
  }

  public createPricing(
    pricing_list: CreatePricingDto,
    financialProfileId: string,
  ): Promise<ICoreResponse> {
    return this.restClient.post(
      formatString(ORGANIZATION_API_PATH.CREATE_PRICING, financialProfileId),
      { pricing_list },
    );
  }
  public updatePricing(
    pricing_list: UpdatePricingDto,
    financialProfileId: string,
  ): Promise<ICoreResponse> {
    return this.restClient.post(
      formatString(ORGANIZATION_API_PATH.UPDATE_PRICING, financialProfileId),
      { pricing_list },
    );
  }
}

export default ManagePricingService;
